import { useNavigate } from "react-router-dom";
import {
  Users,
  Camera,
  Bell,
  BarChart3,
  LineChart,
  ShieldCheck,
  ArrowRight
} from "lucide-react";

const CI_COLOR = "#00bfa5";

export default function Home() {
  const navigate = useNavigate();

  return (
    <div style={styles.page}>
      {/* TOP BAR LOGO */}
      <div style={styles.topBar}>
        <img
          src="/pixels-logo-text.png"
          alt="PIXELS AI"
          style={styles.logoText}
        />
      </div>

      {/* HERO */}
      <section style={styles.hero}>
        <div style={styles.heroContent}>
          {/* Circle Logo */}
          {/* <img
            src="/pixels-logo-circle.png"
            alt="PIXELS AI"
            style={styles.logoCircle}
          /> */}

          <h1 style={styles.title}>
            เปลี่ยนกล้องวงจรปิด <br />
            ให้กลายเป็น <span style={styles.highlight}>Insight & ยอดขาย</span>
          </h1>

          <p style={styles.subtitle}>
            PIXELS AI คือระบบ Smart Analytics ที่เปลี่ยนข้อมูลจากกล้อง
            <br />
            เป็น Dashboard, VIP Tracking และ LINE Notify แบบ Real-time
          </p>

          <div style={styles.heroActions}>
            <button
              style={styles.secondaryBtn}
              onClick={() => navigate("/login")}
            >
              เข้าสู่ระบบ CRM
            </button>
          </div>
        </div>
      </section>

      {/* FEATURES */}
      <section style={styles.section}>
        <div style={styles.grid4}>
          <Feature
            icon={<Users size={36} color={CI_COLOR} />}
            title="Customer Analytics"
            desc="วิเคราะห์จำนวนลูกค้า เพศ อายุ Member และ VIP แบบอัตโนมัติ"
          />
          <Feature
            icon={<Camera size={36} color={CI_COLOR} />}
            title="Smart Device"
            desc="วิเคราะห์ข้อมูลแยกตามสาขา กล้อง และโซน"
          />
          <Feature
            icon={<Bell size={36} color={CI_COLOR} />}
            title="LINE Notify"
            desc="แจ้งเตือนทันทีเมื่อ VIP เข้าร้าน"
          />
          <Feature
            icon={<BarChart3 size={36} color={CI_COLOR} />}
            title="Business Dashboard"
            desc="Dashboard ที่ใช้ตัดสินใจได้จริง"
          />
        </div>
      </section>

      {/* DASHBOARD PREVIEW */}
      <section style={{ ...styles.section, background: "#0f172a" }}>
        <h2 style={styles.sectionTitle}>
          Dashboard ที่ช่วยตัดสินใจได้จริง
        </h2>
        <p style={styles.sectionSub}>
          Real-time • Trend • Heatmap • VIP Tracking
        </p>

        <div style={styles.previewBox}>
          <LineChart size={90} color={CI_COLOR} />
          <p style={{ opacity: 0.6, marginTop: 12 }}>
            ตัวอย่าง Dashboard จาก PIXELS AI
          </p>
        </div>
      </section>

      {/* CTA */}
      <section style={styles.cta}>
        <ShieldCheck size={52} color={CI_COLOR} />
        <h2 style={{ marginTop: 16 }}>
          พร้อมเปลี่ยนข้อมูลให้เป็นกำไรหรือยัง?
        </h2>

        <button
          style={{ ...styles.primaryBtn, marginTop: 24 }}
          onClick={() => navigate("/login")}
        >
          เริ่มใช้งาน PIXELS AI
        </button>
      </section>

      {/* FOOTER */}
      <footer style={styles.footer}>
        © {new Date().getFullYear()} PIXELS AI — Smart CCTV Analytics
      </footer>
    </div>
  );
}

/* -------- SMALL BLOCK -------- */
function Feature({ icon, title, desc }) {
  return (
    <div style={styles.card}>
      {icon}
      <h3>{title}</h3>
      <p>{desc}</p>
    </div>
  );
}

/* ================= STYLES ================= */

const styles = {
  page: {
    background: "#020617",
    color: "#e5e7eb",
    fontFamily: "'Kanit', sans-serif"
  },

  topBar: {
    position: "absolute",
    top: 20,
    left: 24,
    zIndex: 10
  },

  logoText: {
    height: 36
  },

  hero: {
    padding: "140px 24px 120px",
    textAlign: "center",
    background:
      "radial-gradient(circle at top, #1e293b, #020617)"
  },

  heroContent: {
    maxWidth: 900,
    margin: "0 auto"
  },

  logoCircle: {
    width: 90,
    marginBottom: 24
  },

  title: {
    fontSize: "3rem",
    lineHeight: 1.2,
    fontWeight: 600
  },

  highlight: {
    color: CI_COLOR
  },

  subtitle: {
    marginTop: 20,
    fontSize: "1.2rem",
    opacity: 0.85
  },

  heroActions: {
    marginTop: 40,
    display: "flex",
    gap: 16,
    justifyContent: "center",
    flexWrap: "wrap"
  },

  primaryBtn: {
    background: CI_COLOR,
    color: "#020617",
    border: "none",
    padding: "14px 26px",
    borderRadius: 10,
    fontSize: 16,
    fontWeight: 500,
    cursor: "pointer",
    display: "flex",
    alignItems: "center",
    gap: 8
  },

  secondaryBtn: {
    background: "transparent",
    color: CI_COLOR,
    border: `1px solid ${CI_COLOR}`,
    padding: "14px 26px",
    borderRadius: 10,
    fontSize: 16,
    cursor: "pointer"
  },

  section: {
    padding: "90px 24px",
    maxWidth: 1200,
    margin: "0 auto"
  },

  sectionTitle: {
    textAlign: "center",
    fontSize: "2rem"
  },

  sectionSub: {
    textAlign: "center",
    opacity: 0.65,
    marginBottom: 40
  },

  grid4: {
    display: "grid",
    gridTemplateColumns: "repeat(auto-fit, minmax(220px, 1fr))",
    gap: 24
  },

  card: {
    background: "#020617",
    border: "1px solid #1e293b",
    borderRadius: 14,
    padding: 28,
    textAlign: "center"
  },

  previewBox: {
    height: 300,
    borderRadius: 18,
    border: `1px dashed ${CI_COLOR}`,
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    justifyContent: "center",
    marginTop: 40
  },

  cta: {
    padding: "110px 24px",
    textAlign: "center"
  },

  footer: {
    padding: 24,
    textAlign: "center",
    opacity: 0.5,
    fontSize: 14
  }
};
